import { ROOM_SIDEBAR_TAB_CONFIG } from "../../RoomSideBar/roomSidebarTabConfig";
import { createSelector } from "@reduxjs/toolkit";
import { COMPONENT_COLOR_LABELS, IFC_INSTANCE_CLASS_META, type IViewerView } from "@multiconsult-group/multiplacer-core";
import { selectRoomColorings } from "../../Room/roomSelectors";
import { selectArticleColorings } from "../../ViewerRedux/articleColoringSelectors";
import type { IRootState } from "../../app/store";
import { selectViewerView } from "../viewSelectors";

import { selectViewSettingsPreset } from "../viewPresetSelectors";

const describeViewSettings = (
  preset: { name: string; description?: string; view: IViewerView },
  roomColorings: ReturnType<typeof selectRoomColorings>,
  articleColorings: ReturnType<typeof selectArticleColorings>,
) => {
  const { visibility, componentColorMode, roomColoringId } = preset.view;
  const byClass = visibility.mode === "INSTANCE_CLASS";
  const items = byClass ? visibility.ifcClasses : visibility.disciplines.map(ifcClass => ({ ifcClass, opacity: 1 }));
  return {
    validation: preset.view.modules.ROOM_VALIDATION,
    roomPanelLabel: preset.view.roomPanelTab ? ROOM_SIDEBAR_TAB_CONFIG[preset.view.roomPanelTab].label : "Ingen",
    name: preset.name,
    description: preset.description,
    byClass,
    items: items.map(({ ifcClass: key, opacity }) => ({
      key,
      label: byClass ? IFC_INSTANCE_CLASS_META[key]?.label ?? key : key,
      opacityPercent: Math.round(opacity * 100),
    })),
    componentColor: COMPONENT_COLOR_LABELS[componentColorMode],
    articleColor: preset.view.articleColoringId
      ? articleColorings.find(coloring => coloring.id === preset.view.articleColoringId)?.label ?? preset.view.articleColoringId
      : "Ingen",
    roomColor: roomColoringId === null ? "Ingen"
      : roomColorings.find(coloring => coloring.id === roomColoringId)?.title ?? roomColoringId,
  };
};

export const selectViewSettingsDetails = createSelector(
  [selectViewSettingsPreset, selectRoomColorings, selectArticleColorings],
  (preset, roomColorings, articleColorings) => preset ? describeViewSettings(preset, roomColorings, articleColorings) : null,
);
export type IViewSettingsDetails = NonNullable<ReturnType<typeof selectViewSettingsDetails>>;

export const selectViewPresetSaveSnapshot = createSelector(
  [(state: IRootState) => state.design.projectNo,
    selectViewerView, selectRoomColorings, selectArticleColorings],
  (projectNo, view, roomColorings, articleColorings) => projectNo ? {
    projectNo, view,
    details: describeViewSettings({ name: "Gjeldende visning", view }, roomColorings, articleColorings),
  } : null,
);
